export default "__VITE_ASSET__32435aca__"